import { makeStyles } from '@mui/styles';
import { CSSProperties } from 'react';

type StylesProps = {
  textColor?: CSSProperties['color'],
  textSeconaryColor?: CSSProperties["color"]
}

export const useStyles = makeStyles((theme) => ({
  messageItem: {
    padding: theme.spacing(0.5),
    gap: theme.spacing(0.5),
    borderBottom: "2px solid #576871",
  },
  title: {
    fontWeight: 500,
    fontSize: '0.9rem',
    color: (props: StylesProps) => (props.textColor ?? theme.palette.primary.main),
    "&:first-letter": {
      textTransform: "capitalize",
    }
  },
  userMessage: {
    fontWeight: 500,
    fontSize: '0.9rem',
    color: theme.palette.success.dark,
    "&:first-letter": {
      textTransform: "capitalize",
    }
  },
  userMessageIcon: {
    color: theme.palette.success.dark,
  },
  time: {
    color: (props: StylesProps) => (props.textSeconaryColor ?? theme.palette.primary.main),
  }
}));
